import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from '@bibliocommons/base-links';
import { ArrowBack } from '@bibliocommons/base-icons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { readSessionStorageItem } from '@bibliocommons/utils-storage';
import Context from '@bibliocommons/context';

import './BackToLink.scss';

export default function BackToLink({ href, pageId }) {
  const sessionStorage = readSessionStorageItem('backToLink');
  const backToLinkHref = href || sessionStorage?.href;
  const backToLinkPageId = pageId || sessionStorage?.pageId;
  const { setBackToLinkEnabled, mobileApp } = useContext(Context);

  useEffect(() => {
    setBackToLinkEnabled(true);
  }, [setBackToLinkEnabled]);

  return (
    !mobileApp && (
      <div className="cp-back-to-link">
        {backToLinkHref && backToLinkPageId && (
          <Link className="back-to-link" dataKey="back-to-link" href={backToLinkHref}>
            <span aria-hidden>
              <ArrowBack />
              <FormattedMessage id={`back_to_link_${backToLinkPageId}`} />
            </span>
            <ScreenReaderMessage>
              <FormattedMessage id={`sr_back_to_link_${backToLinkPageId}`} />
            </ScreenReaderMessage>
          </Link>
        )}
      </div>
    )
  );
}

BackToLink.propTypes = {
  href: PropTypes.string,
  pageId: PropTypes.string
};
